<template>
  <div v-if="$Can('view_task_report')">
    <b-overlay :show="loading" rounded="sm" no-fade class=" mt-2">

    <b-card>

      <b-card-header>
        <b-card-title class="d-flex justify-content-between align-items-center w-100">
          <div class="d-flex align-items-center">

            {{ selectedReport == 'Time Report' ? 'Task Time Report' : 'Task Clinic Report' }}
        <b-dropdown id="dropdown-time-clinic-report" text="Time Report" variant="link" class="ml-2">
          <template #button-content>
            <span>{{ selectedReport }}</span>
            <i class="fa fa-chevron-down ml-2"></i>
          </template>
          <b-dropdown-item @click="selectReport('Time Report')">Time Report</b-dropdown-item>
          <b-dropdown-item @click="selectReport('Clinic Report')">Clinic Report</b-dropdown-item>
        </b-dropdown>
        </div>
        <div>
          <b-button class="ml-5" variant="success" @click="downloadPDF"
              >Download PDF</b-button
            >
        </div>
      </b-card-title>
    </b-card-header>

      <div
        class="mb-2 text-center d-flex justify-content-center align-items-center"
      >
        <b-row class="">
          <b-col cols="12" lg="4">
            <treeselect
              v-model="selectedDepartments"
              @input="selectedFilters"
              value-consists-of="LEAF_PRIORITY"
              :limit="3"
              :multiple="true"
              :options="departmentOptions"
            />
          </b-col>

          <b-col cols="12" lg="4">
            <treeselect
              v-model="selectedTasks"
              @input="selectedFilters"
              value-consists-of="LEAF_PRIORITY"
              :limit="3"
              :multiple="true"
              :options="taskOptions"
            />
          </b-col>

          <b-col cols="12" lg="4">
            <flat-pickr
              v-model="selectedDates"
              class="form-control bg-white w-100"
              :config="datePickerConfig"
            />
          </b-col>

          <b-col cols="12" lg="12" class="mt-50">
            <b-button class="mr-1" variant="info" @click="selectThisWeek"
              >This Week</b-button
            >
            <b-button class="mr-1" variant="info" @click="selectThisMonth"
              >This Month</b-button
            >
            <b-button class="mr-1" variant="info" @click="selectLastMonth"
              >Last Month</b-button
            >
            <b-button class="mr-1" variant="info" @click="selectNextMonth"
              >Next Month</b-button
            >
            <b-button class="mr-1" variant="info" @click="selectThisYear"
              >This Year</b-button
            >
            <b-button
              v-for="quarter in [1, 2, 3, 4]"
              :key="'q' + quarter"
              class="mr-1"
              variant="info"
              :title="quarterTitle(quarter)"
              @click="selectQuarter(quarter)"
              >Q{{ quarter }}</b-button
            >
          </b-col>
        </b-row>
      </div>

      <b-row class="mt-3 d-flex align-items-center justify-content-center">
      <b-col cols="12" md="12" lg="12" class="mb-3 mb-md-0">
        <b-card>
            <div class="chart-wrapper">
              <canvas id="dailyTasksChart"></canvas>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- <b-row class="mt-3">
        <b-col md="6">
          <b-card>
            <canvas id="taskDistributionByPriorityChart" width="400" height="200"></canvas>
          </b-card>
        </b-col>

        <b-col md="6">
          <b-card>
            <canvas id="taskCompletionRadarChart" width="400" height="200"></canvas>
          </b-card>
        </b-col>
      </b-row> -->
      <b-row cols="12">
        <b-col md="6" class="d-flex justify-content-start">
          <div>
            <b-form-checkbox switch v-model="isReportSummary"
              >
              Summary
              </b-form-checkbox
            >
          </div>
          </b-col>
          <b-col md="6" class="d-flex justify-content-end mb-2">

          <div >
            <b-button variant="success" @click="taskReportDataExport"
              >Export .xlsx</b-button
            >
          </div>
        </b-col>
      </b-row>

      <b-row>
        <InvalidTimesAlert :invalidTimes="invalidTimes" />
      </b-row>

      <b-row >
        <TaskReportTable :taskReportTable="taskReportTable" v-if="!isReportSummary"/>
        <TaskSummaryReportTable :taskReportTable="parsedSummaryReportTable" v-else/>

      </b-row>

    </b-card>

    </b-overlay>
  </div>
  <div v-else class="text-center mt-5 text-danger">
    No Permission
  </div>
</template>

<script>
import reportStoreModule from "./reportStoreModule";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import Chart from "chart.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import TaskReportTable from "./TaskReportTable.vue";
import TaskSummaryReportTable from "./TaskSummaryReportTable.vue";
import InvalidTimesAlert from "./InvalidTimesAlert.vue";
import { toDateRange, yearToQuarterEnd } from "./reportDates";



export default {
  setup() {
    const TASK_REPORT_APP_STORE_MODULE_NAME = "task-report";
    if (!store.hasModule(TASK_REPORT_APP_STORE_MODULE_NAME))
      store.registerModule(
        TASK_REPORT_APP_STORE_MODULE_NAME,
        reportStoreModule
      );
    onUnmounted(() => {
      if (store.hasModule(TASK_REPORT_APP_STORE_MODULE_NAME))
        store.unregisterModule(TASK_REPORT_APP_STORE_MODULE_NAME);
    });
  },

  components: {
    flatPickr,
    Treeselect,
    TaskReportTable,
    TaskSummaryReportTable,
    InvalidTimesAlert
  },

  data() {
    return {
      loading : true,

      isReportSummary:false,
      requestId: 0,
      invalidTimes: null,
      parsedSummaryReportTable : [],
      taskReportTable:[],
      selectedReport:'Time Report',
      selectedDates: [],
      departmentOptions: [],
      taskOptions: [],
      selectedDepartments: [],
      selectedTasks: [],
      datePickerConfig: {
        dateFormat: "d/m/Y",
        mode: "range",
        locale: {
          firstDayOfWeek: 1, // Monday
        },
        onChange: this.onDateChange,
      },
      summary: [],
      charts: {
        taskDistributionByPriorityChart: null,
        dailyTasksChart: null,
        taskCompletionRadarChart: null,
      },
    };
  },

  created() {
    if (this.$Can("view_task_report")) this.setDefaultDates();
  },

  methods: {

    selectReport(report){
      this.selectedReport = report;
      this.renderCharts();
    },
    selectedFilters() {
      this.refresh();
    },

    setDefaultDates() {
      const now = new Date();
      const firstDayOfWeek = now.getDate() - now.getDay() + 1; // Monday
      const lastDayOfWeek = firstDayOfWeek + 6; // Sunday
      const firstDay = new Date(now.setDate(firstDayOfWeek));
      const lastDay = new Date(now.setDate(lastDayOfWeek));
      this.setRange([firstDay, lastDay]);
    },

    setRange(dates) {
      this.selectedDates = dates;
      this.refresh();
    },

    onDateChange(selectedDates) {
      // flatpickr also fires this after the first click of a range; wait for both ends
      if (selectedDates.length !== 2) return;
      if (
        JSON.stringify(this.selectedDates) !== JSON.stringify(selectedDates)
      ) {
        this.setRange(selectedDates);
      }
    },

    // Single entry point for loading the report. The summary table is derived from the
    // same response as the daily table and chart, so every view always reflects the
    // current filters, and a slower earlier request can never overwrite a newer one.
    refresh() {
      const range = toDateRange(this.selectedDates);
      if (!range) return;

      const [startDate, endDate] = range;
      const requestId = ++this.requestId;
      this.loading = true;

      store
        .dispatch("task-report/taskReport", {
          startDate,
          endDate,
          selectedDepartments: this.selectedDepartments,
          selectedTasks: this.selectedTasks,
          isSummary : false
        })
        .then((res) => {
          if (requestId !== this.requestId) return;
          this.summary = res.data.data;
          this.invalidTimes = res.data.invalidTimes;
          this.departmentOptions = res.data.departments;
          this.taskOptions = res.data.tasks;
          this.renderCharts();
        })
        .catch((error) => {
          if (requestId !== this.requestId) return;
          this.loading = false;

          this.$swal({
            title: "Error!",
            text: "Report could not be loaded!" + error,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        });

    },

    renderCharts() {
      // this.renderTaskDistributionByPriorityChart();
      this.renderDailyTasksChart();
      this.createTaskBreakdown();
      this.createSummaryBreakdown();
      // this.renderTaskCompletionRadarChart();
    },

    taskReportDataExport() {
      this.loading = true;

      let reportData = this.isReportSummary ?this.parsedSummaryReportTable.map(task => {
        return {
          task_title: task.task_title,
          count: task.count,
          total_minutes: task.total_minutes
        };
      }) :  this.taskReportTable.map(task => {
        return {
          date: task.date,
          task_title: task.task_title,
          count: task.count,
          total_minutes: task.total_minutes
        };
      });

      store
        .dispatch("task-report/taskReportDataExport", { datas: reportData,isSummary:this.isReportSummary })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/octet-stream",
          });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "task_report.xlsx");
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            title: "Error!",
            text: "Report could not be loaded!" + error,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        });
    },

    renderTaskDistributionByPriorityChart() {
      if (this.charts.taskDistributionByPriorityChart) {
        this.charts.taskDistributionByPriorityChart.destroy();
      }

      const ctx = document
        .getElementById("taskDistributionByPriorityChart")
        .getContext("2d");

      const taskCounts = this.summary.reduce((acc, item) => {
        item.tasks.forEach((task) => {
          acc[task.task_title] =
            (acc[task.task_title] || 0) + task.total_minutes;
        });
        return acc;
      }, {});

      const labels = Object.keys(taskCounts);
      const data = Object.values(taskCounts);
      const backgroundColor = labels.map((label) => {
        const task = this.summary
          .find((item) => item.tasks.find((task) => task.task_title === label))
          .tasks.find((task) => task.task_title === label);
        return task ? task.color.bgColor : "#ccc"; // Eşleşen renk yoksa default bir renk kullan
      });

      this.charts.taskDistributionByPriorityChart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels,
          datasets: [
            {
              label: "Total Task Distribution by Priority",
              data,
              backgroundColor,
            },
          ],
        },
        options: {
          responsive: true,
        },
      });
    },

    renderDailyTasksChart() {
  if (this.charts.dailyTasksChart) {
    this.charts.dailyTasksChart.destroy();
  }

  const ctx = document.getElementById("dailyTasksChart").getContext("2d");

  const dates = this.summary.map((item) => item.date);
  const tasksData = {};

  // Initialize tasksData with an empty array for each date
  this.summary.forEach((item) => {
    item.tasks.forEach((task) => {
      if (!tasksData[task.task_title]) {
        tasksData[task.task_title] = new Array(dates.length).fill(0);
      }
    });
  });

  // Fill tasksData with actual values
  this.summary.forEach((item, dateIndex) => {
    item.tasks.forEach((task) => {
      tasksData[task.task_title][dateIndex] = this.selectedReport === 'Time Report' ? task.total_minutes : task.count;
    });
  });

  const datasets = Object.keys(tasksData).map((task_title) => {
    const taskColor = this.summary
      .flatMap(item => item.tasks)
      .find(task => task.task_title === task_title)?.color?.bgColor || '#000000';

    return {
      label: task_title,
      data: tasksData[task_title].map((value, index) => ({
        x: dates[index],
        y: value,
        hidden: value === 0,
      })),
      backgroundColor: taskColor,
      borderColor: taskColor,
      fill: false,
    };
  });

  this.charts.dailyTasksChart = new Chart(ctx, {
    type: "bar",
    data: {
      labels: dates,
      datasets,
    },
    options: {
      responsive: true,
  maintainAspectRatio: false,
      hover: {
        animationDuration: 0,
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem, data) {
            const dataset = data.datasets[tooltipItem.datasetIndex];
            const value = dataset.data[tooltipItem.index].y;
            if (value !== 0) {
              if (this.selectedReport === 'Time Report') {
                const hours = Math.floor(value / 60);
                const minutes = (value % 60).toString().padStart(2, "0");
                return `${dataset.label}: ${hours}:${minutes}`;
              } else {
                return `${dataset.label}: ${value}`;
              }
            }
            return "";
          }.bind(this),
        },
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              callback: function (value) {
                if (this.selectedReport === 'Time Report') {
                  const hours = Math.floor(value / 60);
                  const minutes = (value % 60).toString().padStart(2, "0");
                  return `${hours}:${minutes}`;
                } else {
                  return value;
                }
              }.bind(this),
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              maxTicksLimit: 12,
            },
          },
        ],
      },
      legend: {
        display: window.innerWidth >= 768, // Display legend only if screen width is 768px or smaller
      },
    },
  });
},

    renderTaskCompletionRadarChart() {
      if (this.charts.taskCompletionRadarChart) {
        this.charts.taskCompletionRadarChart.destroy();
      }

      const ctx = document
        .getElementById("taskCompletionRadarChart")
        .getContext("2d");

      const taskCounts = this.summary.reduce((acc, item) => {
        item.tasks.forEach((task) => {
          acc[task.task_title] =
            (acc[task.task_title] || 0) + task.total_minutes;
        });
        return acc;
      }, {});

      const labels = Object.keys(taskCounts);
      const data = Object.values(taskCounts);

      this.charts.taskCompletionRadarChart = new Chart(ctx, {
        type: "radar",
        data: {
          labels,
          datasets: [
            {
              label: "Task Completion",
              data,
              backgroundColor: "rgba(54, 162, 235, 0.2)",
              borderColor: "rgba(54, 162, 235, 1)",
              pointBackgroundColor: "rgba(54, 162, 235, 1)",
              pointBorderColor: "#fff",
              pointHoverBackgroundColor: "#fff",
              pointHoverBorderColor: "rgba(54, 162, 235, 1)",
            },
          ],
        },
        options: {
          responsive: true,
        },
      });
    },

    selectThisWeek() {
      const now = new Date();
      const firstDayOfWeek = now.getDate() - now.getDay() + 1; // Monday
      const lastDayOfWeek = firstDayOfWeek + 6; // Sunday
      this.setRange([
        new Date(now.setDate(firstDayOfWeek)),
        new Date(now.setDate(lastDayOfWeek)),
      ]);
    },

    selectThisMonth() {
      const now = new Date();
      this.setRange([
        new Date(now.getFullYear(), now.getMonth(), 1),
        new Date(now.getFullYear(), now.getMonth() + 1, 0),
      ]);
    },

    selectLastMonth() {
      const now = new Date();
      this.setRange([
        new Date(now.getFullYear(), now.getMonth() - 1, 1),
        new Date(now.getFullYear(), now.getMonth(), 0),
      ]);
    },

    selectNextMonth() {
      const now = new Date();
      this.setRange([
        new Date(now.getFullYear(), now.getMonth() + 1, 1),
        new Date(now.getFullYear(), now.getMonth() + 2, 0),
      ]);
    },

    selectThisYear() {
      const now = new Date();
      this.setRange([
        new Date(now.getFullYear(), 0, 1),
        new Date(now.getFullYear(), 11, 31),
      ]);
    },

    selectQuarter(quarter) {
      this.setRange(yearToQuarterEnd(quarter));
    },

    quarterTitle(quarter) {
      const [start, end] = yearToQuarterEnd(quarter);
      const fmt = (d) => d.toLocaleDateString("en-GB");
      return `${fmt(start)} - ${fmt(end)}`;
    },

    convertMinutesToHoursMinutes(minutes) {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      return `${hours}:${remainingMinutes.toString().padStart(2, "0")}`;
    },
    convertDateString(dateString) {
      const dateParts = dateString.split("-");
      const year = dateParts[0];
      const month = dateParts[1].padStart(2, "0"); // Ensure two digits for month
      const day = dateParts[2].padStart(2, "0"); // Ensure two digits for day

      return `${day}-${month}-${year}`;
    },

    createTaskBreakdown(){
      const taskAnalysisTable = this.summary
      .map((main) => {
        return main.tasks.map((task) => {
          task.date = this.convertDateString(main.date);
          task.converted_total_minutes = this.convertMinutesToHoursMinutes(task.total_minutes);
          return task;
        });
      })
      .flat();

        // Calculate the total task_count and total_minutes (in minutes)
        const totalTaskAnalysisCount = taskAnalysisTable.reduce((total, item) => total + item.count, 0);
        const totalAnalysisMinutes = taskAnalysisTable.reduce((total, item) => {
          const [hours, minutes] = item.converted_total_minutes.split(':').map(Number);
          return total + (hours * 60) + minutes;
        }, 0);

        // Create the summary row
        const summaryAnalysisRow = {
          count: totalTaskAnalysisCount,
          date: 'Total',
          task_title: '',
          converted_total_minutes: this.convertMinutesToHoursMinutes(totalAnalysisMinutes), // Convert total minutes to hours:minutes
          task_id: '',
        };

        taskAnalysisTable.push(summaryAnalysisRow);

        // Remove converted_total_minutes from the taskAnalysisTable items before using it
        this.taskReportTable = taskAnalysisTable.map(item => {
          const { converted_total_minutes, ...rest } = item;
          rest.total_minutes = item.converted_total_minutes;
          return rest;
        });
        this.loading = false;

    },

    createSummaryBreakdown(){
      // Roll the daily rows up per task so the summary always matches the daily view
      const byTask = {};
      this.summary.forEach((day) => {
        day.tasks.forEach((task) => {
          if (!byTask[task.task_id]) {
            byTask[task.task_id] = {
              task_id: task.task_id,
              task_title: task.task_title,
              color: task.color,
              count: 0,
              total_minutes: 0,
            };
          }
          byTask[task.task_id].count += task.count;
          byTask[task.task_id].total_minutes += task.total_minutes;
        });
      });

      const taskAnalysisTable = Object.values(byTask)
      .map((task) => {
          task.converted_total_minutes = this.convertMinutesToHoursMinutes(task.total_minutes);
          return task;
      });

        // Calculate the total task_count and total_minutes (in minutes)
        const totalTaskAnalysisCount = taskAnalysisTable.reduce((total, item) => total + item.count, 0);
        const totalAnalysisMinutes = taskAnalysisTable.reduce((total, item) => {
          const [hours, minutes] = item.converted_total_minutes.split(':').map(Number);
          return total + (hours * 60) + minutes;
        }, 0);

        // Create the summary row
        const summaryAnalysisRow = {
          count: totalTaskAnalysisCount,
          task_title: 'Total',
          converted_total_minutes: this.convertMinutesToHoursMinutes(totalAnalysisMinutes), // Convert total minutes to hours:minutes
          task_id: '',
        };

        taskAnalysisTable.push(summaryAnalysisRow);

        // Remove converted_total_minutes from the taskAnalysisTable items before using it
        this.parsedSummaryReportTable = taskAnalysisTable.map(item => {
          const { converted_total_minutes, ...rest } = item;
          rest.total_minutes = item.converted_total_minutes;
          return rest;
        });
        this.loading = false;

      },


    downloadPDF() {
  // Ensure the PDF export uses a consistent chart size regardless of on-page responsive sizing
      const range = toDateRange(this.selectedDates);
      if (!range) return;
      // "YYYY-MM-DDT00:00:00" (no Z) parses as local midnight
      const dates = range.map((date) => new Date(date + "T00:00:00"));
      // Temporarily force canvas size to 600x300 for export, then restore
      const canvas = document.getElementById("dailyTasksChart");
      const chart = this.charts.dailyTasksChart;
      let prevWidthStyle = "";
      let prevHeightStyle = "";
      let prevResponsive = true;
      let prevMaintain = true;
      if (canvas && chart) {
        prevWidthStyle = canvas.style.width;
        prevHeightStyle = canvas.style.height;
        prevResponsive = !!chart.options.responsive;
        prevMaintain = !!chart.options.maintainAspectRatio;
        chart.options.responsive = false;
        chart.options.maintainAspectRatio = false;
        canvas.style.width = "600px";
        canvas.style.height = "300px";
        chart.update(0);
      }

      store
        .dispatch("task-report/downloadPDF2", {
          datePeriod:
            dates[0].toDateString() + " to " + dates[1].toDateString(),
          departments: this.departmentOptions
            .filter((e) => {
              return this.selectedDepartments.includes(e.id);
            })
            .map((e) => {
              return e.label;
            })
            .toString(),
          dailyTasksChart: document
            .getElementById("dailyTasksChart")
            .toDataURL(),
          taskAnalysisTable: this.taskReportTable,
          type:this.selectedReport
        })
        .then((res) => {
          // Restore chart sizing after export
          if (canvas && chart) {
            canvas.style.width = prevWidthStyle;
            canvas.style.height = prevHeightStyle;
            chart.options.responsive = prevResponsive;
            chart.options.maintainAspectRatio = prevMaintain;
            chart.update(0);
          }
          if (res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "dashboard-report.pdf");
            document.body.appendChild(link);
            link.click();

            this.$swal({
              title: "Succesfull!",
              text: "✔️ Report is created!",
              icon: "success",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
          }
        })
        .catch((error) => {
          // Restore on error as well
          if (canvas && chart) {
            canvas.style.width = prevWidthStyle;
            canvas.style.height = prevHeightStyle;
            chart.options.responsive = prevResponsive;
            chart.options.maintainAspectRatio = prevMaintain;
            chart.update(0);
          }
          console.error("Error fetching user report:", error);
        });
    },
  },
};
</script>

<style scoped>
canvas {
  max-width: 100%;
}

.chart-wrapper {
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  /* Taller on large screens, reasonable on small screens */
  height: clamp(280px, 40vh, 520px);
}

.chart-wrapper > canvas {
  width: 100% !important;
  height: 100% !important;
}

.total-tasks-display h2 {
  font-size: 4em;
  color: #42a5f5;
  text-align: center;
}

.flat-pickr-wrapper {
  display: flex;
  align-items: center;
}

.flat-pickr-wrapper .form-control {
  margin-right: 1rem;
}

.flat-pickr-wrapper .d-flex {
  flex-wrap: wrap;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
